// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".enterprise_follow-module__container--2SYaI{margin:0;margin-top:16px}\n", ""]);
// Exports
exports.locals = {
	"container": "enterprise_follow-module__container--2SYaI"
};
module.exports = exports;
